/**
 * @deprecated Use I18nService.localeCompareR instead.
 *
 * @description A fast string comparator based on the french locale.
 */
export const frenchSort = new Intl.Collator('fr', { sensitivity: 'base' }).compare;

export function sortValuesByKey<ObjectType>(values: ObjectType[], sortFunction: (a: ObjectType, b: ObjectType) => number): ObjectType[];
export function sortValuesByKey<ObjectType, KeyType>(
    values: ObjectType[],
    sortFunction: (a: KeyType, b: KeyType) => number,
    getKey: (value: ObjectType) => KeyType
): ObjectType[];
export function sortValuesByKey<ObjectType, KeyType>(
    values: ObjectType[],
    sortFunction: (a: KeyType, b: KeyType) => number,
    getKey: (value: ObjectType) => KeyType = ((value: any) => value) as any
): ObjectType[] {
    return [...values]
        .map(value => ({ key: getKey(value), value }))
        .sort(({ key: a }, { key: b }) => sortFunction(a, b))
        .map(({ value }) => value);
}

export function doNotSort<T>(_a: T, _b: T): number {
    return 0;
}
